<template>
    <div class="NddFooter relative bg-[#58B884] py-28">
        <div class="container relative z-[2]">
            <h2 class="mb-4 text-left text-2xl font-black text-white lg:text-4xl lg:leading-[46.8px]">
                <slot name="title" />
            </h2>
            <CText class="text-white">
                <slot name="message" />
            </CText>
            <slot name="body" />
        </div>
        <img
            alt="raketa"
            class="absolute -bottom-px right-6 z-1 h-96 opacity-20 lg:right-20 lg:z-[3] lg:h-[512px] lg:opacity-100 2xl:right-[calc((100vw-1300px)/2)]"
            src="@/assets/images/mentoring/rocket.svg"
        />
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'
</script>
